import * as React from 'react';

function SvgSettingsIcon(props) {
  return (
    <svg
      width={22}
      height={22}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18.241 11.605a.916.916 0 010-1.21l1.174-1.32a.917.917 0 00.11-1.072L17.692 4.83a.917.917 0 00-.981-.44l-1.724.348a.916.916 0 01-1.054-.605l-.559-1.677a.917.917 0 00-.87-.624H8.835a.917.917 0 00-.916.624l-.514 1.677a.917.917 0 01-1.054.605l-1.769-.348a.917.917 0 00-.917.44L1.833 8.003a.917.917 0 00.092 1.072l1.164 1.32a.917.917 0 010 1.21l-1.164 1.32a.917.917 0 00-.092 1.072l1.833 3.172a.917.917 0 00.981.44l1.724-.348a.917.917 0 011.054.605l.559 1.677a.917.917 0 00.917.624h3.666a.916.916 0 00.871-.624l.56-1.677a.917.917 0 011.054-.605l1.723.348a.917.917 0 00.98-.44l1.834-3.171a.916.916 0 00-.11-1.073l-1.238-1.32zm-1.365 1.228l.733.825-1.173 2.035-1.082-.22a2.75 2.75 0 00-3.162 1.834l-.349 1.026H9.496l-.33-1.045a2.75 2.75 0 00-3.162-1.833l-1.082.22-1.191-2.026.733-.825a2.75 2.75 0 000-3.666l-.733-.825 1.173-2.017 1.082.22a2.75 2.75 0 003.162-1.833l.348-1.036h2.347l.348 1.045a2.75 2.75 0 003.163 1.833l1.082-.22 1.173 2.035-.733.825a2.75 2.75 0 000 3.648zm-6.206-5.5a3.667 3.667 0 100 7.334 3.667 3.667 0 000-7.334zm0 5.5a1.834 1.834 0 110-3.667 1.834 1.834 0 010 3.667z"
        fill="#748CAD"
      />
    </svg>
  );
}

export default SvgSettingsIcon;
